var map = {
	"./air_horn.png": 89195,
	"./airplane.png": 33219,
	"./banana.png": 20526,
	"./bra.png": 32085,
	"./cake.png": 89367,
	"./cat.png": 44089,
	"./clown.png": 88321,
	"./coconut.png": 59459,
	"./coffee.png": 28745,
	"./creeper.png": 90191,
	"./cupid_arrow.png": 80924,
	"./dart.png": 18566,
	"./dog.png": 52638,
	"./dolphin.png": 8801,
	"./dynamite.png": 39187,
	"./egg.png": 45686,
	"./firework.png": 49410,
	"./flowers.png": 22346,
	"./fly.png": 77316,
	"./gift.png": 60023,
	"./ice_cream.png": 39622,
	"./item_pack.png": 91994,
	"./kiss.png": 77716,
	"./marmot.png": 36028,
	"./penguin.png": 57399,
	"./pigeon.png": 75984,
	"./piggy_bank.png": 26597,
	"./pillow.png": 36482,
	"./pineapple.png": 69247,
	"./pizza.png": 32617,
	"./plunger.png": 21449,
	"./poo.png": 27583,
	"./pumpkin.png": 28384,
	"./punch.png": 92917,
	"./random.png": 20033,
	"./rooster.png": 44406,
	"./samara.png": 31823,
	"./sheep.png": 83985,
	"./shotgun.png": 3667,
	"./shuriken.png": 77551,
	"./snowball.png": 29653,
	"./squid.png": 76922,
	"./stone.png": 78405,
	"./sumo_wrestler.png": 64969,
	"./titan.png": 12920,
	"./toilet_paper.png": 37206,
	"./tomato.png": 85932,
	"./turkey.png": 81842,
	"./virus.png": 26213,
	"./water_balloon.png": 98474,
	"./watermelon.png": 61598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85958;